import {
  allSounds,
  ability,
  reload,
  click,
  death,
  hit1,
  hit2,
  hit3,
  hit4,
  shot,
  bgm
} from '@components/sound/sounds';
import { parentsHasClass, parentIsButton } from '@components/sound/helpers';
import { MobileAppBus } from '@helpers/mobileApp';
import { useSettingsStore } from '@stores';
import { useEffect } from 'react';

export function Sound() {
  const { muted } = useSettingsStore();

  useEffect (() => {
    bgm.play();

    const clickHandler = (event: MouseEvent) => {
      if (parentIsButton(event.target as Element)) click.play();
      else if (parentsHasClass(event.target as Element, 'btn')) click.play();
    };

    document.addEventListener('click', clickHandler, true);
  }, []);

  const onDeviceMute = () => {
    allSounds.forEach(s => s.mute(true));
  };

  const onDeviceUnmute = () => {
    if (muted) return;
    allSounds.forEach(s => s.mute(false));
  };

  useEffect(() => {
    allSounds.forEach(s => s.mute(muted));

    MobileAppBus.addEventListener('mute', onDeviceMute);
    MobileAppBus.addEventListener('unmute', onDeviceUnmute);

    return () => {
      MobileAppBus.removeEventListener('mute', onDeviceMute);
      MobileAppBus.removeEventListener('unmute', onDeviceUnmute);
    };
  }, [muted]);

  return null;
}

export function playHit() {
  if (useSettingsStore.getState().muted) return;
  const random = Math.floor(Math.random() * 4);
  [hit1, hit2, hit3, hit4][random].play();
}

export function playShot() {
  if (useSettingsStore.getState().muted) return;
  shot.rate(1 + Math.random() * 0.1 - 0.05);
  shot.play();
}

export function playAbility() {
  if (useSettingsStore.getState().muted) return;
  ability.play();
}

export function playReload() {
  if (useSettingsStore.getState().muted) return;
  reload.play();
}

export function playDeath() {
  if (useSettingsStore.getState().muted) return;
  death.play();
}